import {Observable, of, Subject} from 'rxjs';
import { Injectable } from '@angular/core';
import { ApiRouteConfig } from '../../../config/api.route.config';
import { HttpClient } from '@angular/common/http';
import {BuildingMetrics} from '../model/building-metrics';
import * as FileSaver from '../../../../../node_modules/file-saver/FileSaver.min.js';
import {catchError, map, shareReplay, tap} from 'rxjs/operators';
import {AppConfig} from '../../../config/app.config';
import { Multimedium } from '@npm.chapps.com/chapps.common.angular.library/lib/components/multimedium/model/multimedium';
import { BuildingSummary } from '../../common/model/building-summary';
import { StructureType } from '../../common/enums/enums';
import { Address } from '../../common/model/address';
import {CachedApiClientService} from '../../../services/cached-api-client.service';

@Injectable()
export class BuildingDetailsService {

  public updated$: Subject<any> = new Subject<any>();


  constructor(private http: HttpClient, private appConfig: AppConfig, private config: ApiRouteConfig, private cachedApi: CachedApiClientService) {
  }

  public downloadStateReportPdf(rootStructureId: number): Observable<boolean> {
      return this.http.post(
        this.config.getRouteWithInjectedParams(this.config.BUILDING_STATE_REPORT, [rootStructureId.toString()]), {} ,
        {observe: 'response', responseType: 'arraybuffer'}).pipe(
        map((response) => {
            const blob = new Blob([response.body], {type: response.headers.get('content-type')});
            FileSaver.saveAs(blob, response.headers.get('filename'));
            return true;
          },
          err => {
            return false;
          })
      );
  }

  public getBuildingSummary(rootStructureId: number): Observable<BuildingSummary> {
    const endpoint = this.config.getRouteWithInjectedParams(this.config.BUILDING_GET, [rootStructureId.toString()]);

    return this.cachedApi.get<BuildingSummary>(endpoint)
      .pipe(
        catchError(error => {
          return of({address: {}} as BuildingSummary);
        })
      );
  }

  public getBuildingAddress(buildingId: number) : Observable<Address> {
    return this.http.get<any>(this.config.getRouteWithInjectedParams(this.config.BUILDING_ADDRESS, [buildingId.toString()]))
      .pipe(
        map((response) => response.address),
        catchError(error => {
          return of({} as Address);
        })
      );
  }

  public updateAddress(buildingId: number, details: BuildingSummary): Observable<any> {
    return this.http.put(this.config.getRouteWithInjectedParams(this.config.BUILDING_ADDRESS, [buildingId.toString()]), details)
      .pipe(
        tap(() => this.updated$.next(null)),
        catchError(error => {
          return of(null);
        })
      );
  }

  public updatePhoto(buildingId: number, file: File): Observable<Multimedium> {
    const formData: FormData = new FormData();
    formData.append('buildingPhoto', file, file.name);
    return this.http.put<Multimedium>(
      this.config.getRouteWithInjectedParams(this.config.BUILDING_COVER, [buildingId.toString()]),
      formData);
  }

  public getMetrics(bid: string): Observable<BuildingMetrics> {
    return this.http.get<BuildingMetrics>(this.config.getRouteWithInjectedParams(this.config.BUILDING_METRICS, [bid]));
  }

  public getBuildingMultimediumUrl(building?: BuildingSummary): string {
    return building?.multimedium
    ? building.multimedium.url
    : (building?.type === StructureType.SITE ? this.appConfig.SITE_PLACEHOLDER_URL : this.appConfig.BUILDING_PLACEHOLDER_URL);
  }
}
